import { render } from "./TestScreen.vue?vue&type=template&id=543ffb0c&scoped=true"
import script from "./TestScreen.vue?vue&type=script&lang=js"
export * from "./TestScreen.vue?vue&type=script&lang=js"

import "./TestScreen.vue?vue&type=style&index=0&id=543ffb0c&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543ffb0c"]])

export default __exports__